import React from "react";
import { DocumentedComponent } from "../../../shared/components/DocumentedComponent";
import { useAppSelector } from "../../../store";
import { useAppActions } from "../../../shared/hooks";

interface CanvasStateProps {
    children?: any;
    [key: string]: any;
}

function CanvasState(props: CanvasStateProps) {
    // Reserved names are destructured away so author-supplied props can't leak into the published state...
    const { updateCurrentCanvasState: _ignored, parameterValues: _ignored2, currentFrame: _ignored3, children, ...fields } = props;
    const parameterValues = useAppSelector(state => state.storyline.parameterValues);
    const currentFrame = useAppSelector(state => state.storyline.currentParagraph?.data);
    const { updateCurrentCanvasState } = useAppActions();

    React.useLayoutEffect(() => {
        updateCurrentCanvasState(fields);
    }, [parameterValues, currentFrame]);

    return null;
}

(CanvasState as DocumentedComponent).metadata = {
    description: `The \`CanvasState\` component can be used to expose constants, calculated values, function definitions, etc., to the Canvas.  These can be referenced directly by name in any of the canvas bindings and facilitate re-use and additional abstractions.

In the case of a naming conflict between the canvas state, frame data and/or parameter values, the following prioritization is used:

1. Parameter Values
2. Frame Data
3. Canvas State`,
    isSelfClosing: true,
    attributes: []
};

export { CanvasState };
